/**
 * Could potentially use when we get more granular as well.
 * We could wrap this in unveil and pass down props on what
 * "seen types" to pass to the backend. Would likely be
 * wrapped in a mutation. Should also think about removing
 * the logic for the "activity seen" EDAP event, so that we
 * we do not need to execute logic or an additional API
 * call. Might make sense to remove during test clean up.
 */
import {Component} from 'react';
import {compose} from 'redux';
import edap from '../edap';
import {GET_INDICATORS, queryOptions, removeIndicator} from './activity-indicator-graphql';
import {graphql, withApollo} from 'react-apollo';
import {HA_PULSE_ACTIVITY_INDICATORS, hasNewActivity} from './activity-indicator';
import routes from '../../routes';
import {withAuth} from '../../components/auth';
import withAbacusTestValuesAsProps from '../../abacus/with-abacus-test-values-as-props/with-abacus-test-values-as-props';
import {withRouter} from 'react-router-dom';

export class ActivityIndicatorSeen extends Component {
    static defaultProps = {
        data: {},
        location: {},
        testValue: 0
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.triggerActivitySeen();
    }

    shouldComponentUpdate({data: {loading}}) {
        const {data} = this.props;
        return loading !== data.loading;
    }

    componentDidUpdate() {
        this.triggerActivitySeen();
    }

    triggerActivitySeen = () => {
        const {
            boardId,
            client,
            data: {indicators},
            hav,
            location: {state},
            testValue
        } = this.props;

        if (testValue > 0) {
            const hasActivity = hasNewActivity(boardId, indicators);
            const hasSeenIndicator = !!(state && state.referrer && state.referrer === routes.TRIPBOARD);

            /** @edap */
            if (hasActivity && hasSeenIndicator) {
                edap.activitySeen(boardId);
                removeIndicator({boardId, client, hav});
            }
        }
    }

    render() {
        return null;
    }
}

export default compose(
    withAuth,
    graphql(GET_INDICATORS, {options: queryOptions}),
    withAbacusTestValuesAsProps({
        [HA_PULSE_ACTIVITY_INDICATORS]: 'testValue'
    }),
    withApollo,
    withRouter
)(ActivityIndicatorSeen);


// WEBPACK FOOTER //
// ./src/universal/tripboard/activity-indicator/activity-indicator-seen.js